import { useEffect, useMemo, useState } from "react";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { useContentContext } from "../../../app/providers/contextIndex";
import PageSectionRenderer from "../components/PageSectionRenderer";
import "../styles/dynamic-content-page.css";

const SkeletonSection = () => (
    <section className="dynamic-section" style={{ padding: "2rem" }}>
        <Skeleton width="60%" height="2rem" className="mb-3" />
        <Skeleton width="100%" height="1rem" className="mb-2" />
        <Skeleton width="90%" height="1rem" className="mb-2" />
        <Skeleton width="80%" height="1rem" />
    </section>
);

const DynamicContentPage = () => {
    const { activeLandingId } = useOutletContext() || {};
    const { slug = "quienes-somos" } = useParams();
    const { getPageBySlug, getPageBySlugFromBackend } = useContentContext();

    const localContent = useMemo(() => getPageBySlug(activeLandingId, slug) || null, [activeLandingId, getPageBySlug, slug]);

    const [backendContent, setBackendContent] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (localContent) {
            setBackendContent(null);
            return;
        }

        let cancelled = false;
        setLoading(true);

        getPageBySlugFromBackend(slug)
            .then((page) => {
                if (!cancelled) {
                    setBackendContent(page);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setBackendContent(null);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [slug, localContent, getPageBySlugFromBackend]);

    const content = localContent || backendContent;
    const sections = useMemo(() => (Array.isArray(content?.sections) ? content.sections : []), [content]);

    if (loading && !content) {
        return (
            <div className="landing-container dynamic-page">
                <SkeletonSection />
                <SkeletonSection />
            </div>
        );
    }

    return (
        <div className="landing-container dynamic-page">
            {!content ? (
                <section className="dynamic-section">
                    <h1>Página no configurada</h1>
                    <p className="dynamic-description">
                        Esta ruta no tiene contenido todavía. Puedes crearla desde el editor de páginas.
                    </p>
                    <Link to="/gestor-paginas-info" className="dynamic-cta-button">Ir al editor</Link>
                </section>
            ) : null}
            {sections.map((section, index) => (
                <PageSectionRenderer key={`${section?.type || "section"}-${index}`} section={section} index={index} />
            ))}
        </div>
    );
};

export default DynamicContentPage;
